import ContentPage, { Section } from "./ContentPage";
import { REFUNDS } from "../data/legal";

export default function Refunds() {
  return (
    <ContentPage title={REFUNDS.title} updated={REFUNDS.updated} lead={REFUNDS.lead}>
      {REFUNDS.sections.map((section) => (
        <Section
          key={section.heading}
          heading={section.heading}
          body={section.body}
          items={section.items}
        />
      ))}
    </ContentPage>
  );
}
